
import simCardFields from '../../../fields/simCardFields';
import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import SIM_CARDS_STATUS from '../../../enums/SimCardStatus';
import ICONS from '@/common-utils/enums/icons';
import { nsSimCard } from '@/app/i18n/namespaces';

const _simCardStatusIsOneOf = (simCard, statuses) => {
    // Abort the case where the simCard is not loaded yet or where the statuses are invalid
    if (!simCard || !statuses) {
        return false;
    }

    const simCardStatus = simCard[simCardFields.SIM_CARD.STATUS.key];

    return statuses.some(status => simCardStatus === status.name);
};

const _actionHasPermission = ({ permissions, requiredPermissions, hasAtLeastOnePermission }) => {
    return hasRequiredPermissions({ permissions, requiredPermissions, hasAtLeastOnePermission });
};

export default (simCard, permissions, {
    shouldShowPayviewAction,
    shouldShowTerminateAction,
    shouldShowReplaceSimAction,
    isSimActivated,
    isPlanUpdatable,
    isCustomPay,
    activateSimCard,
    terminateSimCard,
    suspendSimCard,
    replaceSimCard,
    reactivateSimCard,
    updateLabel,
    updatePlan
}) => [{
    icon: ICONS.SUBSCRIPTION_ACTIVATE,
    entity: 'actions.row.activate',
    namespace: nsSimCard,
    className: 'text-success',
    onClick: activateSimCard,
    visible: _simCardStatusIsOneOf(simCard, [SIM_CARDS_STATUS.INACTIVE]),
    disabled: (shouldShowPayviewAction
        && !_actionHasPermission({ permissions, requiredPermissions: [Permissions.SIM_ACTIVATE.name, Permissions.SIM_SIERRA_OFFER_LIST.name] }))
        || (!shouldShowPayviewAction
            && !_actionHasPermission({ permissions, requiredPermissions: [Permissions.SIM_ACTIVATE.name, Permissions.GET_OFFERS_FOR_SIM.name] })),
    tooltipForbidden: 'title.permissions.access_denied'
},
{
    icon: ICONS.SIM_CARDS_REACTIVATE,
    entity: 'actions.row.reactivate',
    namespace: nsSimCard,
    className: 'text-success',
    onClick: reactivateSimCard,
    visible: _simCardStatusIsOneOf(simCard, [SIM_CARDS_STATUS.SUSPENDED]),
    disabled: !_actionHasPermission({ permissions, requiredPermissions: [Permissions.SIM_RESUME.name] }),
    tooltipForbidden: 'title.permissions.access_denied'
},
{
    icon: ICONS.REFRESH,
    entity: 'actions.row.replace',
    namespace: nsSimCard,
    onClick: replaceSimCard,
    visible: _simCardStatusIsOneOf(simCard, [SIM_CARDS_STATUS.ACTIVATED]) && shouldShowReplaceSimAction,
    disabled: !_actionHasPermission({ permissions, requiredPermissions: [Permissions.SIM_REPLACE.name] }),
    tooltipForbidden: 'title.permissions.access_denied'
},
{
    icon: ICONS.EDIT,
    namespace: nsSimCard,
    entity: 'actions.row.update_label',
    onClick: updateLabel,
    visible: true,
    disabled: !_actionHasPermission({ permissions, requiredPermissions: [Permissions.SIM_UPDATE.name] }),
    tooltipForbidden: 'title.permissions.access_denied'
},
{
    icon: ICONS.GPRS_SETTINGS,
    namespace: nsSimCard,
    entity: 'actions.row.update_plan',
    onClick: updatePlan,
    visible: !isCustomPay && isSimActivated && isPlanUpdatable,
    disabled: !_actionHasPermission({ permissions, requiredPermissions: [Permissions.GET_OFFERS_FOR_SIM.name] }),
    tooltipForbidden: 'title.permissions.access_denied'
},
{
    icon: ICONS.SIM_CARDS_SUSPEND,
    entity: 'actions.row.suspend',
    namespace: nsSimCard,
    className: 'text-warning',
    onClick: suspendSimCard,
    visible: _simCardStatusIsOneOf(simCard, [SIM_CARDS_STATUS.ACTIVATED]),
    disabled: !_actionHasPermission({ permissions, requiredPermissions: [Permissions.SIM_SUSPEND.name] }),
    tooltipForbidden: 'title.permissions.access_denied'
},
{
    icon: ICONS.SUBSCRIPTION_TERMINATE,
    entity: 'actions.row.terminate',
    namespace: nsSimCard,
    className: 'text-danger',
    variant: 'critical',
    onClick: terminateSimCard,
    visible: _simCardStatusIsOneOf(simCard, [SIM_CARDS_STATUS.ACTIVATED, SIM_CARDS_STATUS.SUSPENDED, SIM_CARDS_STATUS.PREACTIVATED])
        && shouldShowTerminateAction,
    disabled: !_actionHasPermission({ permissions, requiredPermissions: [Permissions.SIM_TERMINATE.name] }),
    tooltipForbidden: 'title.permissions.access_denied'
}
    ];